import { responsiveImage } from "@/lib/helper";
import { Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { ImageAsset } from "../ImageAsset";

const PlaylistInfos = ({ playlist }) => {
  return (
    <Grid container spacing={3}>
      {playlist.type != "toplist" && playlist.image && (
        <Grid item xs={12}>
          <ImageAsset
            url={responsiveImage(playlist.image.formats, 1920)}
            local={true}
            layout="responsive"
            width={1920}
            height={1080}
          />
        </Grid>
      )}
      {playlist.description && (
        <Grid item xs={12}>
          <Typography variant="body1">{playlist.description}</Typography>
        </Grid>
      )}
      {playlist.description && (
        <Grid item xs={12}>
          <Divider />
        </Grid>
      )}
    </Grid>
  );
};

export default PlaylistInfos;
